module.exports = __webpack_public_path__ + "static/media/speechbubble1.940e6e19.svg";